module.exports = __webpack_public_path__ + "static/media/3.d75e6ec7.jpg";